import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap';
import { FaToolbox } from 'react-icons/fa';
import { BsBoxFill } from 'react-icons/bs';

const TypeProduit = ({ setValue, watch }) => {
  const [typeProduit, setTypeProduit] = useState(
    watch('typeProduit') || 'Matériel'
  );

  const handleTypeChange = type => {
    setTypeProduit(type); // Update local state
    setValue('typeProduit', type); // Update form state
  };

  return (
    <>
      <h5>Type de produit</h5>
      <Row className="g-2 mt-3" style={{ height: '70px' }}>
        <Col>
          <Button
            variant="outline-primary"
            className="me-2 mb-1 d-flex align-items-center justify-content-center"
            style={{ height: '100%', width: '100%' }}
            onClick={() => handleTypeChange('Matériel')}
            active={typeProduit === 'Matériel'}
          >
            <BsBoxFill
              style={{ marginRight: '10px', width: '20px', height: '20px' }}
            />
            Matériel
          </Button>
        </Col>
        <Col>
          <Button
            variant="outline-primary"
            className="me-2 mb-1 h-300 d-flex align-items-center justify-content-center"
            style={{ height: '100%', width: '100%' }}
            onClick={() => handleTypeChange('Service')}
            active={typeProduit === 'Service'}
          >
            <FaToolbox
              style={{ marginRight: '10px', width: '20px', height: '20px' }}
            />
            Service
          </Button>
        </Col>
      </Row>
    </>
  );
};

TypeProduit.propTypes = {
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func
};

export default TypeProduit;
